// extracted by mini-css-extract-plugin
export default {"card":"DemographicsCard_card__9vXVW","cardHeader":"DemographicsCard_cardHeader__EhAuB","cardContent":"DemographicsCard_cardContent__dLO-D"};